<h5 mat-dialog-title mat-dialog-draggable-title>{{'title.cancel_sign_flow' | translate }}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h5>
<mat-divider style="padding-bottom: 1rem;"></mat-divider>
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && cancelSignFlow()" appFocusFirstElement>
  <mat-dialog-content>
    <mat-form-field class="mat-full-width">
      <textarea (focusout)="document.reason = document.reason.trim()" matInput type="text" name="reason" id="reason"
        rows="3" [(ngModel)]="document.reason" #reason="ngModel"
        [ngClass]="{ 'is-invalid': f.submitted && reason.invalid }" [placeholder]="'form.reason' | translate"
        maxlength="250" required></textarea>
      <mat-error *ngIf="f.submitted || reason.invalid">
        <span class="text-error" *ngIf="reason?.errors?.required">
          {{'validation.reason' | translate}}
        </span>
      </mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="center" class="pt-2 pb-3">
    <button mat-stroked-button color="primary" type="button" (click)="cancel()" class="mr-2">
      <mat-icon class="mr-0">cancel</mat-icon>{{ "button.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" type="submit" class="ml-2">
      <mat-icon class="mr-0">save</mat-icon>{{ "button.save" | translate }}
    </button>
  </mat-dialog-actions>
</form>
